var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('HeaderCompo',{on:{"headerCompoClick":_vm.headerCompoClick}}),_c('div',{attrs:{"id":"subject"}},[_c('keep-alive',[(this.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!this.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),_c('BottomCompo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }